import {fetchDataFromApi, sendJsonToApi} from './apiHelper';

export const fetchGlobalReportCompanies = () => fetchDataFromApi('post', '/api/common/global-report/companies');
export const fetchGlobalReportManagers = () => fetchDataFromApi('post', '/api/common/global-report/managers');
export const fetchGlobalReportPlatforms = () => fetchDataFromApi('post', '/api/common/global-report/platforms');
export const fetchGlobalReportFields = () => fetchDataFromApi('post', '/api/common/global-report/fields');
export const fetchGlobalReport = (options) => sendJsonToApi('post', '/api/common/global-report', options, 'GlobalReport');
